import React from 'react';
import { Flex } from '@indeed/ifl-components';
import { CheckCircle } from '@indeed/ifl-icons';

import { useRadioCardProps } from './RadioCardContext';
import { RadioCardCommonProps } from './types';
import { CardHeader, CardHeaderProps } from './CardHeader';
import { RadioCardVariants } from './ResumeRadioCard';

export interface RadioCardLabelProps
    extends RadioCardCommonProps,
        Pick<CardHeaderProps, 'title' | 'subtitle' | 'supertitle'> {
    icon?: React.ReactNode;
    children?: React.ReactNode;
    variant?: RadioCardVariants;
    radioCardInputId?: string;
}

export const RadioCardLabel: React.FunctionComponent<RadioCardLabelProps> = ({
    icon,
    title,
    supertitle,
    subtitle,
    children,
    variant,
    sx,
    radioCardInputId,
    'data-testid': dataTestIdProp,
    ...props
}) => {
    const { 'data-testid': radioCardDataTestId } = useRadioCardProps();
    const dataTestId = dataTestIdProp || radioCardDataTestId;

    return (
        <Flex
            as="label"
            htmlFor={radioCardInputId}
            sx={{ gap: 2, flexDirection: 'column', ...sx }}
            data-testid={`${dataTestId}-label`}
            {...props}
        >
            <CardHeader
                iconBefore={icon}
                supertitle={supertitle}
                title={title}
                subtitle={subtitle}
                iconAfter={
                    variant === 'check' && <CheckCircle sx={{ color: 'foreground.status.info' }} />
                }
            />
            {children}
        </Flex>
    );
};
